import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import GridBackUpSection from "./GridBackUpSection";
import Box from "@mui/material/Box";
import ReportSection from "./ReportSection";
import ErrorLogSection from "./ErrorLogSection";
import ReProcessSection from "./ReProcessSection";
import DispatchedJobIdTransferData from "./DispatchedJobIdTransferData";
import JobConfigurations from "./JobConfigurations";
import J2JDataTransfer from "./J2Jdatatransfer";
import Availablejobs from "./Availablejobs";
import CleanData from "./CleanData";
import ActualLob from "./ActualLob";
import GrayOutReport from "./GrayOutReport";
import TniyUrl from "./TniyUrl";
import axios from "axios";
import { baseUrl } from "../Services/Constants";
import { processAndUpdateToken } from "../Services/CommonFunctions";

const Report = (props) => {
  const [msgVisible, setMsgVisible] = useState(false);
  const [msgClass, setMsgClass] = useState("");
  const [msgText, setMsgText] = useState("");
  const [activeTab, setActiveTab] = useState("table1");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [adminConfig, setAdminConfig] = useState("");
  const [globalConfig, setGlobalConfig] = useState("");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const getUserRole = async () => {
    var token = sessionStorage.getItem("token");
    const UserName = sessionStorage.getItem("userName");
    const updatedToken = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${updatedToken}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/Defaultdatum/GetUserRole?userName=" + `${UserName}`,
      { headers }
    );
    setAdminConfig(response?.data?.AdminConfig);
    setGlobalConfig(response?.data?.IsGlobalAdmin);
  }

  useEffect(() => {
    getUserRole();
  }, []);

  return (
    <>
      {(role.includes('report') || globalConfig?.length > 0) ? (
        <div>
          <div style={{ width: "100%" }}>
            <div className="app-container">
              <div style={{ padding: "5px", width: "95%" }}>
                {msgVisible && (
                  <div className="alert-container">
                    <div className={msgClass}>{msgText}</div>
                  </div>
                )}
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                  >
                    {globalConfig?.includes("table1") &&
                      <Tab
                        label="Reprocess section"
                        value="table1"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {(adminConfig?.includes('table2') || globalConfig?.includes("table2")) &&
                      <Tab
                        label="Error logs"
                        value="table2"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes("table3") &&
                      <Tab
                        label="DELETION REPORT"
                        value="table3"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }

                    {globalConfig?.includes('table4') &&
                      <Tab
                        label="BackUp Records"
                        value="table4"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes('table5') &&
                      <Tab
                        label="Transfer Data"
                        value="table5"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes('table6') &&
                      <Tab
                        label="Job Configuration"
                        value="table6"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {(adminConfig?.includes('table7') || globalConfig?.includes("table7")) &&
                      <Tab
                        label="J2J data transfer"
                        value="table7"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes("table8") &&
                      <Tab
                        label="Available Jobs"
                        value="table8"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes("table9") &&
                      <Tab
                        label="Clean Data"
                        value="table9"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {(adminConfig?.includes('table10') || globalConfig?.includes("table10")) &&
                      <Tab
                        label="STP Configuration"
                        value="table10"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes("table11") &&
                      <Tab
                        label="Gray Out Report"
                        value="table11"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                    {globalConfig?.includes("table12") &&
                      <Tab
                        label="Tiny URL"
                        value="table12"
                        style={{ backgroundColor: "white !important" }}
                      />
                    }
                  </Tabs>
                </Box>
                <div>
                  {activeTab === "table1" && globalConfig?.includes("table1") && <ReProcessSection />}
                  {activeTab === "table2" && (adminConfig?.includes('table2') || globalConfig?.includes("table2")) && <ErrorLogSection />}
                  {activeTab === "table3" && globalConfig?.includes("table3") && (
                    <ReportSection activeTab={activeTab} />
                  )}
                  {activeTab === "table4" && globalConfig?.includes("table4") && <GridBackUpSection />}
                  {activeTab === "table5" && globalConfig?.includes("table5") && <DispatchedJobIdTransferData />}
                  {activeTab === "table6" && globalConfig?.includes("table6") && <JobConfigurations />}
                  {activeTab === "table7" && (adminConfig?.includes('table7') || globalConfig?.includes("table7")) && <J2JDataTransfer />}
                  {activeTab === "table8" && globalConfig?.includes("table8") && <Availablejobs />}
                  {activeTab === "table9" && globalConfig?.includes("table9") && <CleanData />}
                  {activeTab === "table10" && (adminConfig?.includes('table10') || globalConfig?.includes("table10")) && <ActualLob />}
                  {activeTab === "table11" && globalConfig?.includes("table11") && <GrayOutReport />}
                  {/* {activeTab === "table12" && globalConfig?.includes("table12") && <TniyUrl />} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : ''}
    </>
  );
};

export default Report;
